import { combineReducers, bindActionCreators } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import UiReducer from './reducers/UiReducer';
import CommonReducer from './reducers/Common';
import BaseReducer from './reducers/Base';

const reducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_DATA':
            return { ...state, data: action.payload };
        default:
            return state;
    }
};

export const rootReducer = combineReducers({
    reducer: reducer,
    ui: UiReducer,
    common: CommonReducer,
    base: BaseReducer
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});


export default store;